import { NSMenuActionProps } from "namirasoft-site-react";
import { EmailSenderRoutes } from "./EmailSenderRoutes";
import { ProviderRow } from "namirasoft-email-sender";

export class EmailSenderMenus
{
	static verify(getIDs: () => string[], getRows: (() => ProviderRow[])): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "Verify",
			isActive: () =>
			{
				if (getIDs().length === 1)
				{
					let rows = getRows();
					if (rows)
						if (rows.length > 0)
							return !rows[0].e_verified;
				}
				return false;
			},
			onClick: {
				action: () =>
				{
					let id = getIDs()[0];
					window.location.href = EmailSenderRoutes.Verify(id);
				},
				showLoading: false
			}
		}
	}
	static send(getIDs: () => string[], getRows: (() => ProviderRow[])): NSMenuActionProps
	{
		return {
			id: "2",
			menu_item: "Send",
			isActive: () =>
			{
				if (getIDs().length === 1)
				{
					let rows = getRows();
					if (rows)
						if (rows.length > 0)
							return rows[0].e_verified;
				}
				return false;
			},
			onClick: {
				action: () =>
				{
					let id = getIDs()[0];
					window.location.href = EmailSenderRoutes.Send(id);
				},
				showLoading: false
			}
		}
	}
}